import { render, staticRenderFns } from "./VSearch.vue?vue&type=template&id=0db189af&scoped=true&"
import script from "./VSearch.vue?vue&type=script&lang=js&"
export * from "./VSearch.vue?vue&type=script&lang=js&"
import style0 from "./VSearch.vue?vue&type=style&index=0&id=0db189af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db189af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0db189af')) {
      api.createRecord('0db189af', component.options)
    } else {
      api.reload('0db189af', component.options)
    }
    module.hot.accept("./VSearch.vue?vue&type=template&id=0db189af&scoped=true&", function () {
      api.rerender('0db189af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/volta/VSearch.vue"
export default component.exports